import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';
import { ApiService } from '@services/api.service';
import { PaginatedResultModel } from '@data-layer/models/common';
import { BillItemsSearchPagination } from '@app/modules/bill-items-management/models';
import { ManagementBillItemModel, ManagementBillItemTotalModel } from '../models/management/bill-items';

@Injectable({
  providedIn: 'root',
})
export class BillItemsManagementRepository {
  constructor(private apiService: ApiService) {}

  public search(
    params: BillItemsSearchPagination,
    isShowLoader: boolean = false,
  ): Observable<PaginatedResultModel<ManagementBillItemModel>> {
    return this.apiService.get<PaginatedResultModel<ManagementBillItemModel>>(
      `${environment.url.prefixCustoms}v2/management/bill-items`,
      {
        params,
      },
      { isShowLoader },
    );
  }

  public total(params: BillItemsSearchPagination, isShowLoader: boolean = false): Observable<ManagementBillItemTotalModel> {
    return this.apiService.get<ManagementBillItemTotalModel>(
      `${environment.url.prefixCustoms}v2/management/bill-items/total`,
      {
        params,
      },
      { isShowLoader },
    );
  }

  public get(id: number, isShowLoader: boolean = true): Observable<ManagementBillItemModel> {
    return this.apiService.get<ManagementBillItemModel>(
      `${environment.url.prefixCustoms}v2/management/bill-items/${id}`,
      {},
      { isShowLoader },
    );
  }

  public updateBillItemWithSpecialRate(id: number, isShowLoader: boolean = false): Observable<never> {
    return this.apiService.put(`${environment.url.prefixCustoms}v2/management/bill-items/${id}/special-rate`, null, null, {
      isShowLoader,
    });
  }
}
